module.exports = __webpack_public_path__ + "static/media/fightscout.77223c5e.png";